<template>
  <div class="cfa-root d-flex align-items-center justify-content-center" style="height: 100vh; background-color: #f7f8fc;">
    <div class="leftBlock">
        <!-- brand -->
        <div class="auth-form-header">
            <a href="/"><div class="auth-form-header-illustration mx-auto"></div></a>
            <div class="auth-form-header-separator"></div>
            <span class="auth-form-header-title"><e style="color: white;">Inscription</e> <small v-if="registrationDone" class="text-success cfa-bold">terminée </small></span>
        </div>
        <transition-group name="fadeY" appear mode="out-in">
          <div v-if="!registrationDone" class=" mb-4">
            <div v-if="!validatedCode" id="" class="auth-form-content ">
                <div class="mt-3">
                    <modern-input @inputChange="(e)=>{this.code = e}" :syncField="syncTime" placeholder="Votre Code" errorText="Champ requis" uid="cfa-email-bloc" type="email" style="width: 25em; left: -1.4em;"></modern-input>
                </div>
            </div>
          </div>
          <div v-if="!registrationDone">
            <!-- form -->
              <div style="padding: 2em .8em 2em .8em; background: var(--primary-color); color: #fff; border-radius: 4px; margin-bottom: 3em; width: 25em; position: relative; text-align: center">
                  <video v-if="validatedCode && codeCompanyLogo == null" width="256" height="256" preload="none" loop="true" muted="muted" playsinline="" style="background: transparent  url('https://cdn-icons-png.flaticon.com/512/6844/6844353.png') 50% 50% / fit no-repeat; width: 3em;height: 3em;margin: auto;position: absolute;top: -1.4em; left: 0; right: 0;" autoplay="autoplay">
                      <source src="https://cdn-icons-mp4.flaticon.com/512/6844/6844353.mp4" type="video/mp4">
                  </video>
                  <div class="d-flex">
                      <div v-if="validatedCode && codeCompanyLogo != null"
                           style="width: 8em;
                                  height: 3em;
                                  margin: auto;
                                  position: absolute;
                                  top: -1.4em;
                                  left: 0px;
                                  right: 0px;
                                  border: 3px solid rgb(156, 221, 225);
                                  background-color: rgb(255, 255, 255);
                                  padding: 0.2em;
                                  border-radius: 5px;"
                           class="d-flex"
                      >
                          <img src="@/assets/img/png/cfa-avatar.png" style="height: 100%;margin: auto;" />
                          <img src="@/assets/img/png/add.png" style="height: 100%;margin: auto;" />
                          <img :src="codeCompanyLogo" style="height: 100%;margin: auto;" />
                      </div>
                  </div>
                  <p v-if="!validatedCode" style="color: white;">Entrez votre code entreprise dans le champ<br> çi-dessus !</p>
                  <p v-else style="color: white;">
                      En poursuivant vous rejoindrai l'organisation <b class="orgBrand">{{ codeCompanyName }}</b> qui prendra en charge l'intégralité de vos frais de sensibilisation !
                  </p>
              </div>

            <div v-if="validatedCode" id="form-ind" class="oauth-form-content">
              <div class="mt-3">
                <select v-model="service_id" class="input dangerFrame mb-4 w-100" style="border-radius: 5px">
                  <option value="" selected disabled>Selectionner un service</option>
                  <option v-for="service in staticService" :key="service.id" :value="service.id">{{ service.name }}</option>
                  <!-- <option v-for="service,i in staticService" :key="i"></option> -->
                </select>
                <!-- <select class="input dangerFrame mb-4 w-100" style="border-radius: 5px">
                  <option>Selectionner votre service</option>
                  <option>{{ codeCompanyName }}</option>
                  <option>Service 2</option>
                  <option>Service 3</option>
                </select> -->
              </div>
              <div class="mt-5">
                <modern-input @inputChange="(e)=>{this.register_email = e}" :syncField="syncTime" placeholder="Votre Adresse Email" errorText="Champ requis" uid="cfa-email-bloc" type="email"></modern-input>
              </div>
              <div class="mt-5">
                <modern-input @inputChange="(e)=>{this.register_firstname = e}" :syncField="syncTime" placeholder="Votre Nom" errorText="Champ requis" uid="cfa-firstname-bloc" type="text"></modern-input>
              </div>
              <div class="mt-5">
                <modern-input @inputChange="(e)=>{this.register_lastname = e}" :syncField="syncTime" placeholder="Vos Prénoms" errorText="Champ requis" uid="cfa-lastname-bloc" type="text"></modern-input>
              </div>
              <div class="mt-5">
                <phone-input @inputChange="catchPhoneInput" :syncField="syncTime" placeholder="Téléphone" errorText="Champ requis" uid="cfa-phone-bloc" type="text"></phone-input>
              </div>
              <div class="mt-3">
                  <label class="d-flex align-items-center cursor-pointer">
                    <input v-model="privacyCheck" id="customCheckLogin" type="checkbox" class="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150" style="margin-right: .5em;"/>
                    <span class="ml-2 text-sm font-semibold text-blueGray-600" :style="{ color: border }">
                      J'accepte la
                      <a href="/generals-conditions" target="_blank" class="text-emerald-5001 link">
                        politique de confidentialité
                      </a>
                    </span>
                </label>
              </div>
            </div>

            <!-- button -->
            <div v-if="!validatedCode" class="auth-form-actions1 mt-5">
              <button v-if="this.code.length < 12" type="submit" class="accent light normal oauth-button disabled">
                  <span class="">Suivant</span>
              </button >
              <button v-else @click="checkCodeValidity" type="submit" id="submitForm1" class="accent light normal oauth-button">
                <span class="" v-if="!waitingAPIResponse">Suivant</span>
                <img v-else src="@/assets/img/gif/load2.gif" alt="loading gif" style="width: 30px;"/>
              </button>
              <a  id="exc2" href="/login" type="button" target="" rel="noopener" class="neutral inverted light oauth-button-light"> J'ai déjà un compte !</a>
            </div>
            <div v-else class="auth-form-actions1 mt-5">
              <button @click="tryRegisterUser" type="submit" id="submitForm1" class="accent light normal oauth-button">
                  <span class="" v-if="!waitingAPIResponse">Terminer mon Inscription</span>
                  <img v-else src="@/assets/img/gif/load2.gif" alt="loading gif" style="width: 30px;"/>
              </button>
              <a  id="exc2" href="/login" type="button" target="" rel="noopener" class="neutral inverted light oauth-button-light"> J'ai déjà un compte !</a>
            </div>
          </div>
          <div v-else class="text-center">
            <!-- image success -->
            <!--<img src="@/assets/img/svg/checked0.svg" alt="" class="mb-2" style="width: 55%;"/>-->
            <video width="256" height="256" preload="none" style="background: transparent  url('https://cdn-icons-png.flaticon.com/512/8717/8717946.png') 50% 50% / fit no-repeat;" autoplay="autoplay" loop="true" muted="muted" playsinline="">
                <source src="https://cdn-icons-mp4.flaticon.com/512/8717/8717946.mp4" type="video/mp4">
            </video>
            <label class="extra-msg mb-2 p-2">Consulter votre boite mail pour procéder à l'activation de votre compte.</label>
            <div class="auth-form-actions1">
              <p style="color: white;">
                J'ai pas reçu le mail&nbsp;
                <a href="#" @click="resentActivationMail">Renvoyer le mail d'activation</a>
              </p>
              <a href="/login" type="button" target="" rel="noopener" class="accent light normal oauth-button"> Me connecter !</a>
            </div>
          </div>
        </transition-group>
    </div>
    <div class="rightBlock px-5 position-relative" v-if="!waitingAPIResponse2">
      <img id="pubImg" v-if="pub != null" class="pub-cfa-block" :src="pub.image"/>
      <img v-else class="cfa-side-logo d-none d-md-block" src="@/assets/brand/spec-brand-1.svg" alt="cyberforceacademy logo">
      <p v-if="pub != null" class="px-5 mb-5">{{ pub?.description }}</p>
      <a v-if="pub != null" :href="pub.link" target="_blank">
        <button type="button" class="accent light normal oauth-button cfa-bg-secondary mt-3">En savoir plus</button>
      </a>
    </div>
    <div class="rightBlock px-5 position-relative" v-else>
      <div class="gZebbraLoader">
        <div id="loading">
          <div class="preloader d-flex flex-column">
            <img src="@/assets/brand/cfa-favicon1.png" alt="cfa preloader">
            <p class="pl-3 fw-bold">loading . . .</p>
          </div>
        </div>
      </div>
    </div>
    <!-- alert -->
    <transition name="fadeY" appear mode="out-in">
      <alert v-if="alertMe" :status="gAlertType" :message="gAlertMessage"></alert>
    </transition>
  </div>
</template>

<script>
import ModernInput from '@/components/shared/input/ModernInput.vue'
import PhoneInput from '@/components/shared/input/PhoneInput.vue'
import { guestAPI } from '@/axios-api.js'
import Alert from '@/components/shared/alert/Alert.vue'

export default {
  name: 'RegistrationWithCodeView',
  components: {
    ModernInput,
    Alert,
    PhoneInput,
  },
  data () {
    return {
      register_email: '',
      register_firstname: '',
      register_lastname: '',
      register_phone: null,
      register_org_name: '',
      register_org_sector: '',
      register_org_mail: 'org@contact.mail',
      register_org_web: 'https://website.domaine',
      register_org_logo: '',
      register_org_phone: null,
      alertMe: false,
      gAlertMessage: '',
      gAlertType: '',
      waitingAPIResponse: false,
      waitingAPIResponse2: true,
      registrationDone: false,
      wait: false,
      syncTime: null,
      border: null,
      privacyCheck: null,
      subscriptionType: null,
      color: null,
      validatedCode: false,
      codeCompanyId: "",
      code: "",
      codeCompanyName: "",
      codeCompanyDescription: "",
      codeCompanyLogo: "",
      serviceAll: [],
      staticService: [],
      service_id: "",
    }
  },
  methods: {
    displayError(error, type='alert-ok', time=5000) {
        this.gAlertMessage = error
        this.gAlertType = type
        this.alertMe = true
        setTimeout(() => {
            this.alertMe = false
        }, time);
    },
    catchPhoneInput (data) {
      this.register_phone = data;
    },
    catchPhoneInputOrg (data) {
      this.register_org_phone = data;
      console.log(this.register_org_phone);
    },
    beep() {
      var snd = new Audio("data:audio/wav;base64,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");
      snd.play();
    },
    onlyNumber(evt) {
      var ASCIICode = (evt.which) ? evt.which : evt.keyCode
      if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) {
        this.beep();
        evt.preventDefault();
      }
      return true;
    },
    tryRegisterUser () {
      if(this.privacyCheck == null) {
          this.border = "#fb3737";
          return;
      }
      else{
          this.border= "#000"
      }

      // if(!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.register_email) || this.register_firstname == '' || this.register_lastname == '' || this.register_phone == null ) {
      //   this.displayError('Oups ! Veuillez remplir les champs convenablement.', 'alert-no');
      //   this.syncTime = Date.now().toString()
      // }
      // else{
        this.waitingAPIResponse = true
        guestAPI.post('accounts/register/add-user-code',
            {
              email: this.register_email,
              firstname: this.register_firstname,
              lastname: this.register_lastname,
              country: this.register_phone.country,
              phone: this.register_phone.phone.replaceAll('-', ''),
              service: this.service_id,
              code: this.code
            })
            .then(response => {
            console.log("Email: ", this.register_email)
              if(response.status == 201) {
                //this.$emit('register', `${this.register_firstname} ${this.register_country}`)
                this.displayError(response.data.message, 'alert-yes', 7000)
                this.registrationDone = true;
                localStorage.setItem('guest_email', this.register_email);
              }
              else {
                this.displayError('Oups ! something went wrong.', 'alert-no')
                this.waitingAPIResponse = false
              }
            })
            .catch(error => {
              localStorage.removeItem('token')
              if (error.response) {
                console.log(error.response)
                this.displayError(error.response.data.message, 'alert-no', 10000)
              }
              else if (error.request) {
                this.displayError('The request was made but no response was received. Please check your network.', 'alert-no', 8000)
              }
              else {
                this.displayError('Oups ! something went wrong.', 'alert-no', 5000)
              }
              this.waitingAPIResponse = false
            })
      //}
    },
    resentActivationMail () {
      guestAPI.post('accounts/resend-email-activate-account/',
      {
        email: localStorage.guest_email,
      })
      .then(response => {
        if(response.status == 200) {
          this.$emit('resent')
          this.displayError("Le mail d'activation vous à été envoyé à nouveau. Veuillez consulter votre boite mail.", 'alert-yes', 8000)
          this.wait = true;
        }
        else {
          this.displayError('Oups ! something went wrong.', 'alert-no')
        }
      })
      .catch(error => {
        localStorage.removeItem('token')
        if (error.response) {
          this.displayError(error.response.data.message, 'alert-no', 10000)
        }
        else if (error.request) {
          this.displayError('The request was made but no response was received. Please check your network.', 'alert-no', 8000)
        }
        else {
          this.displayError('Oups ! something went wrong.', 'alert-no', 5000)
        }
        this.waitingAPIResponse = false
      })
    },
    checkCodeValidity () {
        this.waitingAPIResponse = true
        guestAPI.get(`organisations/verify_code/${this.code}`)
            .then(response => {
                if(response.status == 200) {
                    this.displayError(response.data.message, 'alert-yes', 7000)
                    this.validatedCode = true;

                    this.codeCompanyId = response.data.data.id
                    this.codeCompanyName = response.data.data.name
                    this.codeCompanyDescription = "Concepteur de solution tech"
                    this.codeCompanyLogo = response.data.data.logo

                    this.getService(this.codeCompanyId);
                }
                else {
                    this.displayError('Oups ! something went wrong.', 'alert-no')
                    this.waitingAPIResponse = false
                }
                this.waitingAPIResponse = false
            })
            .catch(error => {
                if (error.response) {
                    this.displayError(error.response.data.message || 'Code invalide !', 'alert-no', 10000)
                }
                else if (error.request) {
                    this.displayError('The request was made but no response was received. Please check your network.', 'alert-no', 8000)
                }
                else {
                    this.displayError('Oups ! something went wrong.', 'alert-no', 5000)
                }
                this.waitingAPIResponse = false
            })
    },
    getService (idOrganis) {
      this.waitingAPIResponse = true
      this.waitingAPIResponse2 = true;
      guestAPI.get(`services/get_all_service?organisation=${idOrganis}`)
      .then(response => {

        console.log("Id: ", idOrganis)

        if (response.status === 200) {
          let services = response.data.data;
          this.staticService = services;
          //this.serviceAll = [];
        }
        else {
          //let msg = 'Oups ! something went wrong.'
          //this.alertString = `${msg}|alert-no|5000::`+Date.now()
        }
        setTimeout(() => {
          this.waitingAPIResponse = false
          this.waitingAPIResponse2 = false;
        }, 2000);
      })
      .catch(error => {
            if (error.response) {
              //this.alertString = `Vous n'appartenez à aucune organisation|alert-no|10000::`+Date.now()
            }
            else if (error.request) {
              //let msg = 'The request was made but no response was received. Please check your network.'
              //this.alertString = `${msg}|alert-no|8000::`+Date.now()
            }
            else {
              //let msg = 'Oups ! something went wrong.'
              //this.alertString = `${msg}|alert-no|5000::`+Date.now()
            }
            this.waitingAPIResponse = false;
            this.waitingAPIResponse2 = false;
          })
    }
  },
  mounted() {
    //this.getService();
    let $ = window.jQuery;
    $(document).ready(function() {
      $('.account-type-block').hover(function() {
        let $tooltip = $('<div class="g-tooltip"></div>');
        if (this.id == 'ind-block') {
          $tooltip.text('Créez un compte individuel et suivez votre parcours en solo.');
        } else {
          $tooltip.text('Créer votre organisation et ajoutez des membres pour le suivi de leur sensibilisation sur l\'ensemble des modules.');
        }
        $('body').append($tooltip);
        $tooltip.css({
          left: $(this).offset().left + $(this).width() - 85,
          top: $(this).offset().top + 40
        });
        $tooltip.show();
      }, function() {
        $('.g-tooltip').remove();
      });
    });

    this.waitingAPIResponse2 = true
    guestAPI.get('pub?key=INSCRIPTION').then(response => {
      if(response.status == 200) {
        this.pub = response.data[0]
      }
      else{
        console.log('Something went wrong !')
      }
      this.waitingAPIResponse2 = false
      // setTimeout(() => {
      //     let img = document.getElementById('pubImg');
      //     console.log(this.pickImageColor(img))
      //
      //     let averageColor = this.calculateAverageColor(img)
      //
      //     document.querySelector('.rightBlock').style.backgroundColor = averageColor;
      // }, 3000)
    }).catch(() => {
      console.log('Something went wrong !')
      this.waitingAPIResponse2 = false
    });
  }
}
</script>

<style scoped>
  .return-link {
    color: var(--primary-color);
    text-decoration: underline;
    cursor: pointer;
  }
  .input-select-adj{
    margin-right: .4em;
  }
  .account-type-block{
    padding: .2em .7em;
    background-color: #f0f0f0;
    border-right: 4px;
  }
  .account-type-block input{
    height: 25px !important;
  }
  .account-type-block label{
    cursor: pointer;
  }
  .extra-msg{
    padding: .2em .4em;
    background-color: #3f3d56;
    color: #fff;
    font-weight: 400;
    margin: 1em;
  }
  @media only screen and (max-width: 600px) {
      .leftBlock{
          width: 100% !important;
          border-bottom-right-radius: 0px !important;
          border-top-right-radius: 0px !important;
          background-color: #262F44;
          font-weight: 400;
      }
      .rightBlock{
          display: none !important;
      }
  }
  .leftBlock{
      height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0em;
      min-width: 30em;
      border-bottom-right-radius: 30px;
      border-top-right-radius: 30px;
      box-shadow: 8px 0 6px #4763881a;
      overflow-y: auto;
      width: 30%;
      z-index: 10;
      background-color: #262F44;
      font-weight: 400;
  }
  .rightBlock{
      width: 70%;
      height: 100vh;
      background-color: #f7f8fc;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
  }
  .rightBlock img{
      margin-bottom: 1em;
      max-width: 100%;
      max-height: calc(100vh - 12em);
  }
  .auth-form {
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: center;
  }
  .auth-form-header {
      display: flex;
      flex-direction: column;
      letter-spacing: .5px;
      text-align: center;
  }
  .auth-form-content{
      width: 22em;
  }
  .auth-form-header .auth-form-header-illustration {
      /* width: 121px;
      height: 30px; */
      width: 181px;
      height: 40px;
      align-self: center;
      margin-bottom: 20px;
      background-image: url(@/assets/brand/logo-1SD.png);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
  }
  .auth-form-header .auth-form-header-separator {
      width: 200px;
      height: 1px;
      align-self: center;
      /* background: #bfcee1; */
      border-bottom: 1px solid #bfcee1;
  }
  .auth-form-header .auth-form-header-title {
      margin-top: 20px;
      margin-bottom: 30px;
      color: #476388;
      font-size: 24px;
      white-space: nowrap;
  }
  .auth-form-link .forgot-password {
      cursor: pointer;
      text-decoration: underline;
  }
  .auth-form-link a {
      color: #476388;
  }
  /* auth actions style */
  .auth-form-actions1 {
      display: flex;
      /*width: 200px;*/
      height: 90px;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      margin-top: 30px;
  }
  .oauth-button{
      background-color: var(--primary-color);
      color: #fff;
      border: none;
      cursor: pointer;
      outline: none;
      text-decoration: none;
      user-select: none;
      position: relative;
      display: flex;
      min-width: 150px;
      height: 34px;
      align-items: center;
      justify-content: center;
      padding: 0 15px;
      border-radius: 17px !important;
      font-size: 14px;
      font-weight: 800;
      letter-spacing: .5px;
      line-height: 32px;
      text-align: center;
      transition: all .15s cubic-bezier(0,0,.2,.1);
      box-shadow: 0 0 6px #47638840;
  }
  .oauth-button:hover{
      background-color: var(--secondary-color);
  }
  .oauth-button-light{
      background-color: #fff;
      color: #6c84a2;
      border: none;
      cursor: pointer;
      outline: none;
      text-decoration: none;
      user-select: none;
      position: relative;
      display: flex;
      min-width: 150px;
      height: 34px;
      align-items: center;
      justify-content: center;
      padding: 0 15px;
      border-radius: 17px !important;
      font-size: 14px;
      font-weight: 800;
      letter-spacing: .5px;
      line-height: 32px;
      text-align: center;
      transition: all .15s cubic-bezier(0,0,.2,.1);
      box-shadow: 0 0 6px #47638840;
  }
  .oauth-button-light:hover{
      color: var(--primary-color);
  }
</style>
